export default "__VITE_ASSET__BYsk58Um__"